import moment from 'moment'

// 转换时间 - 多久之前
export const formatTimeAgo = targetDate => {
  return moment(targetDate).from(new Date())
}

export const formatScheduleTime = (timeStr) => {
  if (!timeStr) return ''
  const target = moment(timeStr)
  const now = moment()
  const timePart = target.format('HH:mm') === '00:00' ? '' : target.format('HH:mm')

  if (target.isSame(now, 'day')) {
    return `Today ${timePart}`
  }
  // Yesterday: now - 1 day
  if (target.isSame(now.clone().subtract(1, 'days'), 'day')) {
    return `Yesterday ${timePart}`
  }
  // Tomorrow: now + 1 day
  if (target.isSame(now.clone().add(1, 'days'), 'day')) {
    return `Tomorrow ${timePart}`
  }

  // Other dates: July 5th HH:mm1
  return `${target.format('MMMM Do')} ${timePart}`
}
